import React, { Fragment } from "react";
import { Carousel, Image } from "react-bootstrap";
import trustFront from "../../assets/images/Billing-Errors.png";
import trustBack from "../../assets/images/Patient-Responsibility.png";
import classes from "./Idcard.module.css";

const idcard = (props) => (
  <Fragment>
    <div className={classes.idSection}>
    <div className="am-id">
      <Carousel
        controls={false}
        interval={9000}
        indicators={true}
        className={classes.carousel}
      >
        <Carousel.Item>
          <div className="am-id">
            <Image src={props.moreYouKnow1} alt="ampsFront" className={classes.idCard} />
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <Image src={props.moreYouKnow2} alt="ampsBack" className={classes.idCard} />
        </Carousel.Item>
      </Carousel>
    </div>

    <div className="tm-id">
      <Carousel
        controls={false}
        interval={9000}
        indicators={true}
        className={classes.carousel}
      >
        <Carousel.Item>
            <Image src={trustFront} alt="trustFront" className={classes.idCard} />
        </Carousel.Item>

        <Carousel.Item>
          <Image src={trustBack} alt="trustBack" className={classes.idCard} />
        </Carousel.Item>
      </Carousel>
    </div>

    </div>
  </Fragment>
);
export default idcard;
